import axios from "axios";
import * as types from '../constants/ActionTypes'

// Url's
const tokenUrl = `http://lpaaswebapi.easyrewardz.com/api/GenerateSecurityToken`;
const enquirySubmitUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaaboutus/enquiry`;
const easyRewardsSearchMemberUrl = `${process.env.REACT_APP_API_URL}get-easy-consumer-details`;
 const updateEasyProfileUrl = `${process.env.REACT_APP_API_URL}update-easymember-profile`;
 const registerEasyAccountUrl = `${process.env.REACT_APP_API_URL}register-easyaccount`;
 const capillarySearchMemberUrl = `${process.env.REACT_APP_API_URL}mobileshop/capillery/serach-member`;
 const updateCapillaryProfileUrl = `${process.env.REACT_APP_API_URL}mobileshop/capillery/update-account`;
 const registerCapillaryAccountUrl = `${process.env.REACT_APP_API_URL}mobileshop/capillery/register-account`;




// Actions
const tokenGenerateRequested = () => ({
    type: types.TOKEN_GENERATE_REQUEST
  });

const tokenGenerateSuccess = data => ({
  type: types.TOKEN_GENERATE_SUCCESS,
  data
});

const tokenGenerateFailure = error => ({
  type: types.TOKEN_GENERATE_FAILURE,
  error
});

//Enquiry form 

const searchMemberRequested = () => ({
  type: types.SEARCH_MEMBER_REQUEST
});

const searchMemberSuccess = data => ({
type: types.SEARCH_MEMBER_SUCCESS,
data
});

const searchMemberFailure = error => ({
type: types.SEARCH_MEMBER_FAILURE,
error
});

const updateEasyProfileRequested = () => ({
  type: types.UPDATE_EASY_PROFILE_REQUEST
});

const updateEasyProfileSuccess = data => ({
type: types.UPDATE_EASY_PROFILE_SUCCESS,
data
});

const updateEasyProfileFailure = error => ({
type: types.UPDATE_EASY_PROFILE_FAILURE,
error
});

const registerEasyAccountRequested = () => ({
  type: types.REGISTER_EASY_ACCOUNT_REQUEST
});

const registerEasyAccountSuccess = data => ({
type: types.REGISTER_EASY_ACCOUNT_SUCCESS,
data
});

const registerEasyAccountFailure = error => ({
type: types.REGISTER_EASY_ACCOUNT_FAILURE,
error
});
const clearCapillaryInfo = () => ({
  type:types.CLEAR_CAPILLARY_INFO
})


//Enquiry form 

const searchCapillaryMemberRequested = () => ({
  type: types.SEARCH_CAPILLARY_MEMBER_REQUEST
});

const searchCapillaryMemberSuccess = data => ({
type: types.SEARCH_CAPILLARY_MEMBER_SUCCESS,
data
});

const searchCapillaryMemberFailure = error => ({
type: types.SEARCH_CAPILLARY_MEMBER_FAILURE,
error
});

const updateCapillaryProfileRequested = () => ({
  type: types.UPDATE_CAPILLARY_PROFILE_REQUEST
});

const updateCapillaryProfileSuccess = data => ({
type: types.UPDATE_CAPILLARY_PROFILE_SUCCESS,
data
});

const updateCapillaryProfileFailure = error => ({
type: types.UPDATE_CAPILLARY_PROFILE_FAILURE,
error
});

const registerCapillaryAccountRequested = () => ({
  type: types.REGISTER_CAPILLARY_ACCOUNT_REQUEST
});

const registerCapillaryAccountSuccess = data => ({
type: types.REGISTER_CAPILLARY_ACCOUNT_SUCCESS,
data
});

const registerCapillaryAccountFailure = error => ({
type: types.REGISTER_CAPILLARY_ACCOUNT_FAILURE,
error
});


// API
export const getEasyRewardsToken = () => {
  return dispatch => {
    dispatch(tokenGenerateRequested());
    axios.post(tokenUrl, 
        {
 UserName: "Theblissclub",
 UserPassword: "Theblissclub123",
 DevId: "ad3f6bef-3efb-42e6-9061-e6c10cd4b62f",
 AppId: "12a822b5-b4bc-4fe3-84a9-08212144909f",
 ProgramCode: "Theblissclub"
}  , {
          headers: {
            'Access-Control-Allow-Origin':'No',
            //'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            
            'Content-Type': 'application/json; charset=UTF-8'
          },
      
    })
      .then(res => {
        if (res) {
          dispatch(tokenGenerateSuccess(res));
        } else {
          dispatch(tokenGenerateFailure(res));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(contactDataFailure(err.message));
      });
  };
};

//Enquiry form save function 


export const easyRewardsSearchMember = (data) => {
  return (dispatch) => {
    dispatch(searchMemberRequested());

    return axios
      .get(easyRewardsSearchMemberUrl, {
        params: {
          mobile_no: data.mobile_no,
          token: data.token,
          easyUrl: data.urlEasy,
        },
      })
      .then((res) => {
        if (res.data) {
          dispatch(searchMemberSuccess(res));
            localStorage.setItem('mobile_no',data.mobile_no)
        } else {
          dispatch(searchMemberFailure(res));
           localStorage.setItem('mobile_no',data.mobile_no)
        }
        return res; // ✅ Return response to the caller
      })
      .catch((err) => {
        dispatch(searchMemberFailure(err.message));
        throw err;
      });
  };
};


export const updateEasyProfileMember = (data) => {
  return dispatch => {
    dispatch(updateEasyProfileRequested());
    axios.get(updateEasyProfileUrl, {params:{
      mobile_no : data.mobile_no,
      token: data.token,
      firstName: data.firstName,
      lastName: data.lastName,
      emailId: data.emailId,
      address1: data.address1,
      address2: data.address2,
      pinCode: data.pinCode,
      store_code: data.store_code,
      username : data.username


    }} )
      .then(res => {
        if (res.data) {
          dispatch(updateEasyProfileSuccess(res));
        } else  {
          dispatch(updateEasyProfileFailure(res));
        } 
      })
      
      .catch(err => {
          throw err;
        // dispatch(contactDataFailure(err.message));
      });
  };
};

export const registerEasyAccount = (data) => {
  return dispatch => {
    dispatch(registerEasyAccountRequested());
    return axios.get(registerEasyAccountUrl, { // 👈 return added here
      params: {
        mobile_no: data.mobile_no,
        token: data.token,
        firstName: data.firstName,
        lastName: data.lastName,
        emailId: data.emailId,
        address1: data.address1,
        address2: data.address2,
        pinCode: data.pinCode,
        store_code: data.store_code,
        username: data.username
      }
    })
    .then(res => {
      if (res.data) {
        dispatch(registerEasyAccountSuccess(res));
        return res.data; // 👈 return result for awaiting
      } else {
        dispatch(registerEasyAccountFailure(res));
        return null;
      }
    })
    .catch(err => {
      dispatch(registerEasyAccountFailure(err));
      throw err; // 👈 propagate error to caller
    });
  };
};

export const capillarySearchMember = (data) => {
  return async (dispatch) => {
    dispatch(searchCapillaryMemberRequested());

    try {
      const res = await axios.get(capillarySearchMemberUrl, {
        params: {
          mobile_no: data.mobile_no,
          connection_id: data.connection_id,
        },
      });

      if (res.data.status) {
        dispatch(searchCapillaryMemberSuccess(res));
      } else {
        dispatch(searchCapillaryMemberFailure(res));
      }

      localStorage.setItem("mobile_no", data.mobile_no);

      return res; // ✅ return response to caller
    } catch (err) {
      dispatch(searchCapillaryMemberFailure(err.message));
      throw err; // keep error handling same as before
    }
  };
};


export const updateCapillaryProfileMember = (data) => {
  return async (dispatch) => {
    dispatch(updateCapillaryProfileRequested());

    try {
      const res = await axios.get(updateCapillaryProfileUrl, {
        params: {
          connection_id: data.connection_id,
          mobile_no: data.mobile_no,
          firstName: data.firstName,
          lastName: data.lastName,
          emailId: data.emailId,
          address1: data.address1,
          address2: data.address2,
          address3: data.address3,
          stateName: data.stateName,
          countryName: data.countryName,
          townName: data.townName,
          pinCode: data.pinCode,
          dateofbirth: data.dob
        }
      });

      if (res.data) {
        dispatch(updateCapillaryProfileSuccess(res));
        return res.data;   // ✅ IMPORTANT — return so await works
      } else {
        dispatch(updateCapillaryProfileFailure(res));
        return null;
      }

    } catch (err) {
      dispatch(updateCapillaryProfileFailure(err));
      throw err;  // ✅ propagate error
    }
  };
};

export const registerCapillaryAccount = (data) => {
  return async (dispatch) => {
    dispatch(registerCapillaryAccountRequested());

    try {
      const res = await axios.get(registerCapillaryAccountUrl, {
        params: {
          mobile_no: data.mobile_no,
          connection_id: data.connection_id,
          firstName: data.firstName,
          lastName: data.lastName,
          emailId: data.emailId,
          address1: data.address1,
          address2: data.address2,
          address3: data.address3,
          pinCode: data.pinCode,
          countryName: data.countryName,
          stateName: data.stateName,
          townName: data.townName,
        }
      });
      if (res.data) {

        dispatch(registerCapillaryAccountSuccess(res));
        return res.data; // allows awaiting
      } else {
        dispatch(registerCapillaryAccountFailure(res));
        return null;
      }

    } catch (err) {
      dispatch(registerCapillaryAccountFailure(err));
      throw err; // propagate error to caller
    }
  };
};
export const clearCapillaryDetails = () => {
  return dispatch => {
    dispatch(clearCapillaryInfo());
  }
}

